module.exports = __webpack_public_path__ + "img/icon_btn_return.3a2b3020.svg";